import React from 'react';

/**
 * Edpies Logo Component
 * Three stacked bars forming E with a small dot next to the bottom bar
 */
const EdpiesLogo = ({ size = 'md', className = '', showBackground = true }) => {
  const sizes = {
    sm: { container: 'w-8 h-8', svg: 32 },
    md: { container: 'w-10 h-10', svg: 40 },
    lg: { container: 'w-12 h-12', svg: 48 },
    xl: { container: 'w-16 h-16', svg: 64 },
    '2xl': { container: 'w-20 h-20', svg: 80 },
  };

  const { container, svg } = sizes[size] || sizes.md;

  return (
    <div className={`${container} ${className}`}>
      <svg
        width={svg}
        height={svg}
        viewBox="0 0 100 100"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        {/* Purple rounded square background */}
        {showBackground && (
          <rect x="0" y="0" width="100" height="100" rx="22" fill="#7C3AED" />
        )}
        
        {/* Three horizontal bars forming E */}
        {/* Top bar */}
        <rect x="18" y="20" rx="5" width="45" height="12" fill="white"/>
        
        {/* Middle bar - shorter */}
        <rect x="18" y="44" rx="5" width="35" height="12" fill="white"/>
        
        {/* Bottom bar */}
        <rect x="18" y="68" rx="5" width="45" height="12" fill="white"/>
        
        {/* Small dot next to the bottom bar */}
        <circle cx="78" cy="74" r="7" fill="white"/>
      </svg>
    </div>
  );
};

export default EdpiesLogo;
